module.exports = __webpack_public_path__ + "static/media/filter-right-arrow.700f956d.svg";